<template>
    <div id="agentLogin">
        <div>
            <h2>
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#se-icon-elephant"></use>
                </svg>
                <span>合作商登录</span>
            </h2>
            <form>
                <div class="formLine">
                    <input type="text" placeholder="请输入账号" v-model="loginForm.accountName">
                </div>
                <div class="formLine">
                    <input type="password" placeholder="请输入密码" v-model="loginForm.pwd">
                </div>
                <div class="formLine">
                    <mt-button v-if="loginBtn" type="primary" size="large" @click.prevent="agentLoginHandler">登录</mt-button> 
                </div>     
                <div class="formLine">
                    <mt-button v-if="app == 0" type="primary" size="large" @click.prevent="appLink">小象客服APP下载</mt-button> 
                </div>             
            </form>    
        </div>

        <!-- 公众号才显示APP下载链接 -->
        <!-- <p v-if="app == 0" style="padding:10px 0 0 10px;line-height:20px"> 
            APP下载链接：
            <span style="color:red;">请复制下方链接到浏览器打开下载</span>
            <br>
            <input id="copy" value="http://szyanyun.com/app-elephant.apk" style="width:240px;"/>
            <button style="margin-left:5px;color:#fff;background:#FF9C3C;border:1px solid #FF9C3C;border-radius:2px;" @click="copy()">复制</button>
        </p>
        <p v-if="app == 0" style="text-align:center;padding-top:5px;line-height:20px;"><img src="../../assets/download-guide.png" alt="" style="width:300px"></p> -->
        


        <!-- 修改密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel" 
            style="z-index: 2000; min-height: 55%; min-width: 80%;"
            v-show="showPasswordPanel"
            :style="{top:passwordPanelTop+'%'}">   

          <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
            <!-- 原密码输入框 -->
            <p>原密码：</p>
            <van-field type="password"   v-model="oldPassword" />
         
            <!-- 新密码输入框 -->
            <p>新密码：</p>
            <van-field  type="password"  v-model="newPassword" />

            <!-- 再次确认密码输入框 -->
            <p>再次确认：</p>
            <van-field type="password"   v-model="confirmPassword" />

            <div class="confirmChangePassword">
              <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToChangePassword()">确 定</van-button>
            </div>
            
        </div>
        <!-- 修改密码框 end  -->

    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            loginForm: {
                accountName: localStorage.getItem('accountName') ? localStorage.getItem('accountName') : '',
                pwd: ''
            },

            loginBtn: true,

            //修改密码
              showPasswordPanel: false,

              oldPasswordKeyboard : false,
              newPasswordKeyboard : false,
              confirmPasswordKeyboard : false,

              oldPassword:'',
              newPassword:'',
              confirmPassword:'',
              passwordPanelTop: 50,
              //修改密码 end

              app: 0 //地址是否带有参数app=android
        }        
    },
    methods: {
        agentLoginHandler(){
            var data = this.loginForm;
            wxRequest('xxtx/wx/sysUser/login', data, 'post').then(res => {
                if(res.data.code == 200){
                    var token = res.data.data.token;
                    localStorage.setItem('token', token);
                    localStorage.setItem('accountName', this.loginForm.accountName);
                    localStorage.setItem('nickName', res.data.data.nickName);
                    sessionStorage.setItem('isLogin', true);//判断有没有登录，客服页面需要判断
                    this.$store.state.token = token;
                    this.$router.push('/agent/home');
                }else if(res.data.code == 410){
                    this.$store.state.iccid = res.data.data.id;
                    localStorage.setItem('token', res.data.data.token);
                    this.$dialog.alert({message:res.data.message});
                    this.showPasswordPanel = true;
                }
                else{
                    this.$messagebox.alert(res.data.message)
                }
            })            
        },


        /***   修改密码     ***/

        cancelChangePassword(){
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
          this.passwordPanelTop = 50;
          this.showPasswordPanel = false;
        },

        sureToChangePassword(){
          if(this.newPassword!=this.confirmPassword){
            this.$dialog.alert({message:"两次输入的新密码不一致"});
            return ;
          }


          let data = {
            id: this.$store.state.iccid,
            oldPwd: this.oldPassword,
            newPwd: this.confirmPassword,

          }
          wxRequest('sysUser/updatePwd', data, 'post').then(res => {
            if(res.data.code == 200){
              Toast.success(res.data.message);
              this.cancelChangePassword();
            }else{
              this.$dialog.alert({message:res.data.message})
            }
          });
        },
        
        /***   修改密码  end   ***/



        //判断是否微信登陆
        isWeiXin() {
            var ua = window.navigator.userAgent.toLowerCase();
            console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },

        //复制app下载链接
        copy(){
            let copy = document.getElementById('copy');
            copy.select();
            document.execCommand("Copy");
            copy.blur();
            Toast({
                message: '已复制',
                duration: 1500
            })
        },
        appLink(){
            window.location.href = 'https://lh2424.lanzous.com/itIqjeerdkd'
        }
    },
    created(){
        
        // if (this.isWeiXin()) {
        //     let url = window.location.href;
        //     if(url.indexOf('test.szxxtx.com')<0){
        //         this.loginBtn = false;
        //        this.$messagebox.alert('此域名登录权限受限');
        //     }
        // } 
        if(window.location.href.indexOf('app=android') > 0){
            localStorage.setItem('app', 1);
            this.app = localStorage.getItem('app');
        }

    }
}
</script>



<style lang="less">
.changePasswordPanel{
  padding: 10px;

  .icon-cross{
    position: absolute; 
    right: 10px;
    font-size: 16px;
  }

  p{
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword{
      display:flex;
      justify-content: flex-end;
      margin-top: 20px;

      .confirmChangePasswordBtn{
          width: 80px;
          margin: 0 15px;
      }
  }

}
</style>